import TagMenu, { TagMenuProps } from './TagMenu';
import withInteractor from './TagMenu.interactor';
import withPresenter from './TagMenu.presenter';
  
export type { TagMenuProps };
export default withInteractor(withPresenter(TagMenu));

